import React from 'react';
import _ from 'lodash';
import '../assets/css/components/student-section-card.css';

const StudentSectionCard = ({ section, course}) => {
  const getInstructorNameOrCourse = (courseId)=> {
    //TODO: this is a temporary solution since I can't find the query that is returning
    //the excess instructor information. 
    const instructor = _.find(course.instructors, {course_id:courseId})
    return instructor.profile.last_name ? instructor.profile.last_name : course.name
  }

  return(
    <div className="col-sm-12 col-md-6 col-lg-3 m-b-10 student-section-card">
      <div className='ar-1-1'>
        <div className='card no-border bg-primary widget widget-loader-circle-lg no-margin'>
          <div className="card-block">
            <div className="pull-bottom bottom-left bottom-right padding-25">
              <br/>
              <p className="section-name text-white">{section.name}</p>
              <p className="content-name text-white">{getInstructorNameOrCourse(section.course_id)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StudentSectionCard;